const canUseWindow = () => {
    return typeof window !== 'undefined';
};

const canUseDOM = () => {
    return typeof document !== 'undefined';
};

export { canUseWindow, canUseDOM };



// WEBPACK FOOTER //
// ./src/domain/ssrTools.ts